module.exports = __webpack_public_path__ + "img/045be1b.svg";